// extracted by mini-css-extract-plugin
module.exports = {"welcomeCard":"dashboard_welcomeCard__FVKFC","titleContainer":"dashboard_titleContainer__2fD4i","card":"dashboard_card__2qpce"};